import React from 'react';
import Button from '@material-ui/core/Button';
import useButtonStyles from './useButtonStyles';
import { useHistory } from 'react-router-dom';

/**
 * Custom styled Material-UI Button component.
 *
 * @type {React.ForwardRefExoticComponent<
*   React.PropsWithoutRef<import('@material-ui/core').ButtonProps & {
*     variant?: 'primary' | 'secondary' | 'tertiary' | 'tertiaryWrap',
*     size?: 'small' | 'medium' | 'large',
*     color?: 'brand' | 'state' | 'grey' | 'info' | 'succ' | 'warn' | 'error',
*     to?:string,
*     minWidth?:boolean,
*   }> & React.RefAttributes<HTMLButtonElement>
* >}
*/
const SButton = React.forwardRef(({
    variant = 'primary',
    size = 'small',
    color = 'brand',
    darkColor = false,
    children,
    minWidth = false,
    to,
    onClick,
    ...props
}, ref) => {

    let history = useHistory();
    const classes = useButtonStyles({ variant, size, color, minWidth ,darkColor});

    const hClick = (e) => {
        e?.currentTarget?.blur();
        return to ? history?.push(to) : onClick && onClick();
    };

    return (
        <Button
            ref={ref}
            classes={{ root: classes.root }}
            disableFocusRipple={['tertiary', 'tertiaryWrap'].includes(variant)}
            disableRipple={['tertiary', 'tertiaryWrap'].includes(variant)}
            onClick={hClick}
            disableElevation
            {...props}
            variant="contained"
            size="small"
        >
            {children}
        </Button>
    );
});


export default SButton;
